<template>
  <div class="gb-zb-msg gb-zb-msg-left gb-zb-loader">
    <svg id="typing_bubble" data-name="typing bubble" xmlns="http://www.w3.org/2000/svg" width="60" height="22" viewBox="0 0 60 22">
      <g>
        <circle class="dot" cx="06" cy="10" r="5" />
        <circle class="dot" cx="24" cy="10" r="5" />
        <circle class="dot" cx="42" cy="10" r="5" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
.gb-zb-widget-wrapper svg {
  display: block;

  .dot {
    fill: rgba(158, 158, 158, .7);
    transform-origin: 50% 50%;
    animation: ball-beat 1.1s 0s infinite cubic-bezier(0.445, 0.050, 0.550, 0.950);
  }

  .dot:nth-child(2) {
    animation-delay: 0.3s !important;
  }

  .dot:nth-child(3) {
    animation-delay: 0.6s !important;
  }
}

@keyframes ball-beat {
  0% {
    opacity: 0.7;
  }
  33.33% {
    opacity: 0.55;
  }
  66.67% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
</style>
